export class InitListener {
    public static bindContentInserted(onInserted: (event: Event) => void): void {
        document.addEventListener("app:content:inserted", onInserted);
    }
}
